import React from 'react';

import BlockSerializer from 'lib/sanity/ui/BlockSerializer';
import { ArticlePortableText } from 'lib/sanity/types';

export interface ArticleMarketSpecificContentProps {
  content?: ArticlePortableText;
}

const ArticleMarketSpecificContent = ({ content }: ArticleMarketSpecificContentProps) => {
  if (!content) {
    return null;
  }

  return <BlockSerializer blocks={content} />;
};

export default ArticleMarketSpecificContent;
